export default __webpack_public_path__ + "static/media/minus.9e7177f1.svg";